import { render } from "./SecondPage.vue?vue&type=template&id=ade981ae"
import script from "./SecondPage.vue?vue&type=script&lang=js"
export * from "./SecondPage.vue?vue&type=script&lang=js"

import "./SecondPage.vue?vue&type=style&index=0&id=ade981ae&lang=css"
script.render = render

export default script